import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyArOXMVJY6iLZOcEY5u72ZXHrqjic-SzS4",
  authDomain: "sharethedeal.firebaseapp.com",
  projectId: "sharethedeal",
  storageBucket: "sharethedeal.firebasestorage.app",
  messagingSenderId: "1091148217057",
  appId: "1:1091148217057:web:54a210a40299286bb515a0"
};

// Initialize Firebase app instance
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

/**
 * Requests notification permission from the browser and registers the device token
 * @param {string} accessToken - The user's current backend JWT authentication token
 */
export async function registerFCMToken(accessToken) {
  try {
    // 1. Request user permission
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('Notification permission denied by user.');
      return;
    }

    // 2. Fetch unique device token natively (Firebase automatically targets /firebase-messaging-sw.js)
    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY, 
    });

    if (!token) {
      console.error('No registration token available. Check permissions.');
      return;
    }

    console.log('Device FCM Token secured:', token);

    // 3. Send this token to your backend route
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
    const response = await fetch(`${backendUrl}/notifications/register-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`, 
      },
      body: JSON.stringify({ token }),
    });

    const resData = await response.json();
    if (!response.ok) throw new Error(resData.msg || 'Failed backend token save.');

    console.log('Token bound to profile successfully on backend.');

  } catch (error) {
    console.error('Error executing FCM lifecycle flow:', error);
  }
}

// 4. Handle incoming notifications while the user is actively using the app (Foreground)
export const listenForForegroundMessages = () => {
  return onMessage(messaging, (payload) => {
    console.log('Message received in foreground: ', payload);
    alert(`[New Discount Alert!] ${payload.notification.title}\n${payload.notification.body}`);
  });
};